/* The Bhakti Centre booking: class calendar for a page or the homepage.
   Needs bhakti-booking.js loaded first. */
(function () {
  'use strict';
  if (window.BhaktiCalendar) { window.BhaktiCalendar.scan(); return; }
  var U = window.BhaktiBooking && window.BhaktiBooking.u;
  if (!U) return;
  var DAY_MS = U.DAY_MS;
  var ROOT = U.ROOT;
  var MONTHS = U.MONTHS;
  var WD = U.WD;
  var CAT_LABEL = U.CAT_LABEL;
  var FILTERS = U.FILTERS;
  var ICON_X = U.ICON_X;
  var F = U.F;
  var timeStr = U.timeStr;
  var timeRange = U.timeRange;
  var dayKey = U.dayKey;
  var pad = U.pad;
  var money = U.money;
  var esc = U.esc;
  var spacesText = U.spacesText;
  var load = U.load;
  var addToCart = U.addToCart;
  var stepper = U.stepper;
  var dietField = U.dietField;
  var withDiet = U.withDiet;

  function initCalendar(root) {
    if (root.dataset.bkReady) return;
    root.dataset.bkReady = '1';
    var win = Number(root.dataset.bkWindow) || 61;
    var compact = root.dataset.bkMode === 'compact';
    var sessions = load(root, win);
    var byId = {}, byDay = {};
    sessions.forEach(function (s) {
      byId[s.id] = s;
      var k = dayKey(s.start);
      (byDay[k] = byDay[k] || []).push(s);
    });
    function q(sel) { return root.querySelector(sel); }
    var grid = q('[data-bk-grid]'), listEl = q('[data-bk-listview]'), monthEl = q('[data-bk-month]');
    var filtersEl = q('[data-bk-filters]'), modal = q('[data-bk-modal]'), toast = q('[data-bk-toast]');
    var prevBtn = q('[data-act="prev"]'), nextBtn = q('[data-act="next"]');
    var todayKey = dayKey(new Date()), endKey = dayKey(new Date(Date.now() + win * DAY_MS));
    var months = [];
    var y = Number(todayKey.slice(0, 4)), m = Number(todayKey.slice(5, 7)) - 1;
    var ey = Number(endKey.slice(0, 4)), em = Number(endKey.slice(5, 7)) - 1;
    while (y < ey || (y === ey && m <= em)) { months.push([y, m]); m++; if (m > 11) { m = 0; y++; } }
    var st = { mi: 0, filter: 'all', sel: null, qty: 1, opener: null, timer: null };
    var uid = 'bk' + Math.random().toString(36).slice(2, 8);

    function catOf(s) { return s.cat === 'masterclass' ? 'yoga' : s.cat; }
    var present = {};
    sessions.forEach(function (s) { present[catOf(s)] = true; });
    var filters = FILTERS.filter(function (f) { return f[0] === 'all' || present[f[0]]; });
    function visible(s) { return st.filter === 'all' || catOf(s) === st.filter; }

    function renderFilters() {
      if (filters.length < 3) { filtersEl.innerHTML = ''; return; }
      filtersEl.innerHTML = filters.map(function (f) {
        return '<button type="button" class="bk-chip bk-c-' + f[0] + '" data-act="filter" data-f="' + f[0] + '" aria-pressed="' + (st.filter === f[0]) + '">' +
          '<span class="bk-dot" aria-hidden="true"></span>' + f[1] + '</button>';
      }).join('');
    }

    function evBtn(s) {
      var aria = s.label + ', ' + F.long.format(s.start) + ', ' + timeStr(s.start) + (s.full ? ', full' : '');
      return '<button type="button" class="bk-ev bk-c-' + esc(s.cat) + (s.full ? ' is-full' : '') + '" data-act="open" data-id="' + esc(s.id) + '" aria-label="' + esc(aria) + '">' +
        '<span class="bk-ev__time">' + esc(timeStr(s.start)) + (s.full ? ', full' : '') + '</span>' +
        '<span class="bk-ev__name">' + esc(s.label) + '</span></button>';
    }

    function renderGrid() {
      var y = months[st.mi][0], m = months[st.mi][1];
      monthEl.textContent = MONTHS[m] + ' ' + y;
      prevBtn.disabled = st.mi === 0;
      nextBtn.disabled = st.mi === months.length - 1;
      var offset = (new Date(Date.UTC(y, m, 1)).getUTCDay() + 6) % 7;
      var dim = new Date(Date.UTC(y, m + 1, 0)).getUTCDate();
      var h = WD.map(function (w) { return '<div class="bk-wd" aria-hidden="true">' + w + '</div>'; }).join('');
      var cells = 0, i;
      var prevDim = new Date(Date.UTC(y, m, 0)).getUTCDate();
      for (i = 0; i < offset; i++, cells++) {
        h += '<div class="bk-day is-off is-other" aria-hidden="true"><div class="bk-day__n">' + (prevDim - offset + 1 + i) + '</div></div>';
      }
      for (var d = 1; d <= dim; d++, cells++) {
        var key = y + '-' + pad(m + 1) + '-' + pad(d);
        var off = key < todayKey || key > endKey;
        var items = off ? [] : (byDay[key] || []).filter(visible);
        h += '<div class="bk-day' + (off ? ' is-off' : '') + '"><div class="bk-day__n">' + d +
          (key === todayKey ? '<span class="bk-today">Today</span>' : '') + '</div>' + items.map(evBtn).join('') + '</div>';
      }
      var nd = 1;
      while (cells % 7) { h += '<div class="bk-day is-off is-other" aria-hidden="true"><div class="bk-day__n">' + (nd++) + '</div></div>'; cells++; }
      grid.innerHTML = h;
    }

    function renderList() {
      var items;
      if (compact) {
        var lim = Date.now() + 7 * DAY_MS;
        items = sessions.filter(function (s) { return visible(s) && s.start.getTime() <= lim; });
      } else {
        var prefix = months[st.mi][0] + '-' + pad(months[st.mi][1] + 1);
        items = sessions.filter(function (s) { return visible(s) && dayKey(s.start).slice(0, 7) === prefix; });
      }
      if (!items.length) {
        listEl.innerHTML = '<p class="bk-empty">' + (compact ? 'Nothing to book in the next seven days for that choice.' : 'Nothing to book this month for that choice.') + '</p>';
        return;
      }
      var html = '', day = '';
      items.forEach(function (s) {
        var k = dayKey(s.start);
        if (k !== day) {
          html += (day ? '</div>' : '') + '<div class="bk-lday"><h3>' + (k === todayKey ? 'Today, ' : '') + esc(F.long.format(s.start)) + '</h3>';
          day = k;
        }
        var sub = timeRange(s) + ', ' + money(s.price) + (s.full || s.left === Infinity ? '' : ', ' + spacesText(s));
        html += '<button type="button" class="bk-lrow bk-c-' + esc(s.cat) + (s.full ? ' is-full' : '') + '" data-act="open" data-id="' + esc(s.id) + '">' +
          '<span class="bk-lrow__bar" aria-hidden="true"></span><span class="bk-lrow__txt"><span class="bk-lrow__name">' + esc(s.label) +
          (s.note ? ' <span class="bk-note">' + esc(s.note) + '</span>' : '') + '</span>' +
          '<span class="bk-lrow__sub">' + esc(sub) + '</span></span>' +
          '<span class="bk-pill">' + (s.full ? 'Full' : 'Book') + '</span></button>';
      });
      listEl.innerHTML = html + '</div>';
    }

    function renderAll() { renderFilters(); renderGrid(); renderList(); }

    function renderModal() {
      var s = st.sel;
      var facts = '<div class="bk-panel__facts"><div><span>Price per ticket</span><strong>' + money(s.price) + '</strong></div>' +
        '<div><span>Spaces left</span><strong>' + (s.full ? 'Full' : (s.left === Infinity ? 'Available' : s.left)) + '</strong></div></div>';
      var action = s.full
        ? '<p class="bk-panel__full">This one is full. Try another date, or get in touch about the waiting list.</p>'
        : stepper(st.qty, s.left, 'Tickets') + (s.diet ? dietField(uid + 'd') : '') +
          '<button type="button" class="button button--full-width" data-act="add">Add to basket, ' + money(s.price * st.qty) + '</button>' +
          '<p class="bk-msg" data-bk-pmsg role="status"></p>';
      modal.innerHTML = '<div class="bk-panel bk-c-' + esc(s.cat) + '" role="dialog" aria-modal="true" aria-labelledby="' + uid + '">' +
        '<div class="bk-panel__top"><div><span class="bk-badge">' + esc(s.note || CAT_LABEL[s.cat] || 'Class') + '</span>' +
        '<h3 id="' + uid + '">' + esc(s.title) + '</h3>' +
        '<div class="bk-panel__when">' + esc(F.long.format(s.start) + ', ' + timeRange(s)) + '</div></div>' +
        '<button type="button" class="bk-round" data-act="close" aria-label="Close">' + ICON_X + '</button></div>' +
        facts + action +
        '<a class="bk-panel__link" href="' + esc(s.url) + '">More about this class</a></div>';
    }

    function openModal(id, opener) {
      var s = byId[id];
      if (!s) return;
      st.sel = s; st.qty = 1; st.opener = opener;
      renderModal();
      modal.hidden = false;
      var f = modal.querySelector('[data-act="close"]');
      if (f) f.focus();
    }

    function closeModal() {
      if (modal.hidden) return;
      modal.hidden = true;
      modal.innerHTML = '';
      var id = st.sel && st.sel.id;
      st.sel = null;
      var back = id && (root.querySelector('[data-act="open"][data-id="' + id + '"]'));
      if (back && back.offsetParent !== null) back.focus();
    }

    function showToast(html) {
      toast.innerHTML = html;
      toast.classList.add('is-on');
      clearTimeout(st.timer);
      st.timer = setTimeout(function () { toast.classList.remove('is-on'); }, 5000);
    }

    function add(btn) {
      var s = st.sel, qty = st.qty, pm = modal.querySelector('[data-bk-pmsg]');
      btn.disabled = true;
      if (pm) pm.textContent = 'Adding to your basket';
      var dIn = modal.querySelector('[data-bk-diet]');
      addToCart(withDiet([{ id: Number(s.id), quantity: qty }], dIn && dIn.value)).then(function () {
        if (s.left !== Infinity) { s.left -= qty; s.full = s.left <= 0; }
        closeModal();
        renderAll();
        showToast('Added to your basket. <a href="' + ROOT + 'cart">View basket</a>');
      }).catch(function (err) {
        btn.disabled = false;
        if (pm) pm.textContent = err.message;
      });
    }

    root.addEventListener('click', function (e) {
      if (e.target === modal) { closeModal(); return; }
      var b = e.target.closest('[data-act]');
      if (!b || !root.contains(b)) return;
      var a = b.dataset.act;
      if (a === 'prev' && st.mi > 0) { st.mi--; renderAll(); }
      else if (a === 'next' && st.mi < months.length - 1) { st.mi++; renderAll(); }
      else if (a === 'filter') {
        st.filter = b.dataset.f; renderAll();
        var again = filtersEl.querySelector('[data-f="' + st.filter + '"]');
        if (again) again.focus();
      }
      else if (a === 'open') openModal(b.dataset.id, b);
      else if (a === 'close') closeModal();
      else if ((a === 'dec' && st.sel && st.qty > 1) || (a === 'inc' && st.sel && st.qty < st.sel.left)) {
        var dOld = modal.querySelector('[data-bk-diet]'), keep = dOld ? dOld.value : '';
        st.qty += a === 'inc' ? 1 : -1;
        renderModal();
        var dNew = modal.querySelector('[data-bk-diet]');
        if (dNew) dNew.value = keep;
        modal.querySelector('[data-act="' + a + '"]').focus();
      }
      else if (a === 'add') add(b);
    });
    modal.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });

    renderAll();
  }

  function scan() { document.querySelectorAll('[data-bk-calendar]').forEach(initCalendar); }
  window.BhaktiCalendar = { scan: scan };
  scan();
  document.addEventListener('shopify:section:load', scan);
})();